import { render } from "./XeMonitorMock.vue?vue&type=template&id=2f2d5b12&scoped=true"
import script from "./XeMonitorMock.vue?vue&type=script&lang=js"
export * from "./XeMonitorMock.vue?vue&type=script&lang=js"

import "./XeMonitorMock.vue?vue&type=style&index=0&id=2f2d5b12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2d5b12"]])

export default __exports__